import EditProjectsContainer from "../containers/EditProjectsContainer";

const EditProjectsPage = () => {
  return (
    <EditProjectsContainer />
  );
};

export default EditProjectsPage;
